/* eslint-disable array-callback-return */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable prefer-arrow-callback */
import {
  CalendarPicker, LocalizationProvider, PickersDay, PickersDayProps,
} from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
  Badge, Typography, Stack,
} from '@mui/material';
import { Box, styled } from '@mui/system';
import {
  add, compareAsc, differenceInDays, differenceInMonths, format, formatISO, getMonth, startOfMonth, sub,
} from 'date-fns';
import { vi } from 'date-fns/locale';
import { memo, useMemo, useState } from 'react';
import { uniqueId } from 'lodash';
// import { setReturnDate, setSelectedDate } from '../../slices/calendar/calendarSlice';
import { useAppSelector } from '@/utils/hook';
import { calendarVN } from '@/utils/calendarVietNam';
import { ICustomCalendarPickerProps } from './type';
import { style } from '@/styles/globals';
import { matchPriceOrDash } from '@/utils/matchPriceOrDash';
import { useRouter } from 'next/router';
import RedirectAlert from '../RedirectAlert';
import { useBoolean } from '@/utils/hooks';
// import { setSelectedDate } from '../../slices/calendar/calendarSlice';

const StyledBox = styled(Box)`
  display: flex;
  alignItems: flex-end;

  .MuiCalendarPicker-root {
    width: 100%;
  }
  .MuiPickersDay-root.Mui-disabled {
    color: ${style.color.black6} !important
  }
  .MuiTypography-caption {
    display: none;
  }
  .MuiCalendarPicker-root > div:first-of-type {
    display: none;
  }
  .MuiCalendarPicker-root.StyledCalendarPicker>div:nth-of-type(2)>div:first-of-type {
    // display: none;
  }
  .PrivatePickersFadeTransitionGroup-root > div:first-of-type > div:first-of-type {
    // display: none;
  }
  .MuiCalendarPicker-viewTransitionContainer > div:first-of-type > div:first-of-type {
    // display: none;
  }
  .MuiCalendarPicker-root.StyledCalendarPicker > div:nth-of-type(2) > div:first-of-type {
    // display: none;
  }
  .MuiCalendarPicker-root.StyledCalendarPicker > div:nth-of-type(2) > div:first-of-type  {
    // display: none;
  }
  .MuiCalendarPicker-root.StyledCalendarPicker > div:nth-of-type(2) > div[style*="opacity: 1"] {
    display: inherit;
  }
  .PrivatePickersSlideTransition-root {
    min-height: 0;
  }
  .PrivatePickersSlideTransition-root > div:first-of-type {
    position: relative;
  }
  .PrivatePickersSlideTransition-root > div:first-of-type > div {
    justify-content: space-around;
    margin: 0;
  }
  .MuiBadge-root {
    height: 70px;
  }
  .MuiBadge-root > button, .MuiPickersDay-root {
    flex: 1 1 1px;
    height: 54px;
    margin: 0;
  }
`;
const FullWidthStyledBox = styled(Box)({
  width: '100%',
});
const StyledButton = styled(Badge)({
  flexGrow: 1,
  zIndex: 0,
  padding: 0,
  minWidth: 0,
});
const SmallBadge = styled(Badge)({
  fontSize: 0,
  position: 'absolute',
  top: '0',
  zIndex: 2,
});
const StyledFromToContainer = styled(Box)({
  position: 'absolute',
});

const CustomBadge = ({ children, isRight, ...props }: any) => (
  <SmallBadge
    componentsProps={{
      badge: {
        style: {
          padding: '0',
          background: 'rgba(255, 255, 255, 0.2)',
          color: 'white',
          alignItems: 'flex-end',
          alignContent: 'flex-end',
          borderRadius: isRight ? '0 0 0 30%' : '0 0 30% 0',
          // paddingBottom: isRight ? 0 : '2px',
          height: 15,
          top: isRight ? 6 : 1,
          right: isRight ? 3 : 0,
          textAlign: 'center',
        },
      },
    }}
    {...props}
    badgeContent={<span style={{ fontSize: '10px' }}>{children}</span>}
  />
);

const Hidden = Box;
const toDateIsoString = (date: Date) => formatISO(date, { representation: 'date' });
const CustomCalendarPicker = ({
  highlightToday,
  monthAdded,
  dayPriceObj,
  selectedDate,
  setSelectedDate,
  showCalendarLunar,
  showStyleLunar,
  isNotShowPrice,
  seo,
  isVcms,
  lang,
}: ICustomCalendarPickerProps) => {
  // const selectedDate = useAppSelector((state) => state.calendar.selectedDate);

  // const dispatch = useDispatch();

  const today = new Date();
  const addedMonthDate = add(today, { months: monthAdded });
  const selectedDepartDate = new Date(selectedDate.depart);
  const selectedReturnDate = selectedDate.return ? new Date(selectedDate.return) : null;
  let selectedDepartDateInMonth = null as Date | null;
  let selectedReturnDateInMonth = null as Date | null;
  let isBetweenDepartAndReturn = false;

  const departMonth = getMonth(selectedDepartDate) + 1;
  const returnMonth = selectedReturnDate ? getMonth(selectedReturnDate) + 1 : null;
  const addedMonth = getMonth(addedMonthDate) + 1;

  if (departMonth && departMonth === addedMonth) {
    selectedDepartDateInMonth = selectedDepartDate;
  }
  if (returnMonth && returnMonth === addedMonth) {
    selectedReturnDateInMonth = selectedReturnDate;
  }

  const selectedDepartDateMonthStart = startOfMonth(selectedDepartDate);
  const selectedReturnDateMonthStart = selectedReturnDate ? startOfMonth(selectedReturnDate) : null;
  const addedMonthDateMonthStart = startOfMonth(addedMonthDate);

  if (
    (selectedDepartDateMonthStart
      && selectedReturnDateMonthStart
      && differenceInMonths(addedMonthDateMonthStart, selectedDepartDateMonthStart) >= 0
      && differenceInMonths(selectedReturnDateMonthStart, addedMonthDateMonthStart) >= 0)
    || (selectedDepartDate
      && !selectedReturnDate
      && getMonth(selectedDepartDate) === getMonth(addedMonthDate))
  ) {
    isBetweenDepartAndReturn = true;
  }

  const minPriceObj = useMemo(() => {
    const obj: any = {};

    if (!dayPriceObj) return obj;

    Object.keys(dayPriceObj).map((key) => {
      const monthKey = `${key.split('-')[0]}-${key.split('-')[1]}`;
      if (monthKey in obj) {
        obj[monthKey] = Math.min(obj[monthKey], dayPriceObj[key]);
      } else {
        obj[monthKey] = dayPriceObj[key];
      }
    });
    return obj;
  }, [dayPriceObj]);
  const CalendarDateMemo = memo(
    function CalendarDateComponent(
      {
        day, pickersDayProps = {} as any, dateNo, month, year, isMinPrice,
      }: {
        day: Date,
        dateNo: number,
        month: number,
        year: number,
        pickersDayProps: PickersDayProps<Date>,
        isMinPrice: boolean;
      },
    ) {
      const chooseReturn = useAppSelector((state) => state.calendar.chooseReturn);
      const isShowCalendarVietNam = useAppSelector((state) => state.calendar.showCalendarVietNam);
      const flightData = useAppSelector((state) => state.flightData);
      const { query } = useRouter();
      const isReturn = query?.type === 'return';

      const { outsideCurrentMonth } = pickersDayProps;
      let matchDepartDate = false;
      let matchReturnDate = false;
      let matchInBetweenDate = false;
      const dateString: string = format(new Date(day), 'EEEEEE');
      const isDayInWeekend = /Sa|Su/i.test(dateString);
      const isAfterToday = compareAsc(day, sub(today, { days: 1 })) > 0;
      const isBeforeToday = compareAsc(day, today) <= 0;
      const [param, setParam] = useState<any>({});
      const [open, setOpen] = useBoolean(false);
      const [vcms, setVcms] = useState<boolean>(!!isVcms);
      // ! Notice
      const currDayIsoString = toDateIsoString(day);
      if (selectedDepartDateInMonth) {
        matchDepartDate = toDateIsoString(selectedDepartDateInMonth) === currDayIsoString;
      }
      if (selectedReturnDateInMonth) {
        matchReturnDate = toDateIsoString(selectedReturnDateInMonth) === currDayIsoString;
      }
      let dayPrice: string;
      if (dayPriceObj) {
        const date = format(new Date(day), 'yyyy-MM-dd');
        dayPrice = !isNotShowPrice ? matchPriceOrDash(!dayPriceObj[date] ? 0 : Math.round((dayPriceObj[date]) / 1000)) : ''; // if no value, shot not display 0
      }

      if (selectedDepartDate
        && selectedReturnDate
        && !matchReturnDate
        && compareAsc(selectedDepartDate, day) < 0
        && compareAsc(day, selectedReturnDate) < 0) {
        matchInBetweenDate = true;
      }

      const departBadge = chooseReturn && !outsideCurrentMonth && matchDepartDate
        ? (
          <CustomBadge style={{
            width: '10px',
            top: 5,
            left: lang?.lang === 'en' ? 10 : 0,
            textAlight: 'center',
          }}
          >
            {lang?.SearchBar?.flightsTab?.calendarFrom || 'Đi'}
          </CustomBadge>
        )
        : null;
      const returnBadge = chooseReturn && !outsideCurrentMonth && matchReturnDate
        ? (
          <CustomBadge
            style={{
              left: lang?.lang === 'en' ? 10 : 0,
              right: 7,
              width: '10px',
              textAlight: 'center',
            }}
            isRight
          >
            {lang?.SearchBar?.flightsTab?.calendarReturn || 'Về'}
          </CustomBadge>
        )
        : null;
      const dayVN = calendarVN.fromGregorian(year, month, dateNo) as any;
      const isDayInNewYear = showStyleLunar && ((dayVN.month === 12 && dayVN.day >= 25) || (dayVN.month === 1 && dayVN.day <= 4));
      const setSelectedDateVcms = (paramData: any) => {
        setParam(paramData);
        setSelectedDate(paramData);
      };

      const DateComponent = (
        { isShowDateCalendarVietNam }:
        { isShowDateCalendarVietNam: boolean },
      ) => (
        <Stack sx={{
          width: '100%',
          marginTop: '14px',
        }}
        >
          <span style={{
            width: '100%',
          }}
          >
            <PickersDay
              {...pickersDayProps as any}
          // selected={matchDepartDate || matchReturnDate}
              onDayFocus={() => { }}
              onDaySelect={() => {
                let setFn = setSelectedDate;
                if (vcms) {
                  setFn = setSelectedDateVcms;
                }
                if (day) {
                  if (selectedReturnDate || !chooseReturn) {
                    // dispatch(setSelectedDate({
                    //   dateObj: JSON.stringify({
                    //     depart: day,
                    //     return: null,
                    //   }),
                    // }));
                    setFn({
                      depart: day,
                      return: null,
                    });
                  } else if (selectedDepartDate) {
                    if (compareAsc(selectedDepartDate, day) > 0) {
                      // dispatch(setSelectedDate({
                      //   dateObj: JSON.stringify({
                      //     depart: day,
                      //     return: null,
                      //   }),
                      // }));
                      setFn({
                        depart: day,
                        return: null,
                      });
                    } else {
                      // dispatch(setReturnDate({ return: day.toISOString() }));
                      setFn({ return: day });
                    }
                  }
                }
              }}
              focusRipple
              centerRipple
              style={{
                height: '35px',
                width: '100%',
                display: 'block',
                ...(isBeforeToday ? { borderRadius: '6px' } : { borderRadius: '0px' }),
                ...(isAfterToday && (isDayInWeekend) && { color: '#CF1322' }),
                ...(matchInBetweenDate
                  ? { background: seo ? '#FFF6D6' : style.color.blue4 }
                  : {}),
                ...(matchDepartDate || matchReturnDate
                  ? {
                    background: seo ? style.primary.yellow : style.color.blue3,
                    color: seo ? style.neutral.black : 'white',
                  }
                  : {}),
                ...(matchReturnDate
                  ? {
                    borderRadius: '3px 0px 0px 3px',
                  }
                  : {}),
                ...(matchDepartDate
                  ? (selectedDate.return === null || matchReturnDate) ? {
                    borderRadius: '8px',
                  } : {
                    borderRadius: '3px 0px 0px 3px',
                  }
                  : {}),
              }}
              sx={{
                position: 'relative',
                border: 'none !important',
                '&:hover': {
                  border: `1.5px solid ${style.color.blue2}`,
                  backgroundColor: `${style.color.white}`,
                },
              }}
            >
              {/* {departBadge
            && (
              <StyledFromToContainer style={{
                left: 1,
                top: 18,
              }}
              >
                ||
              </StyledFromToContainer>
            )}
              {returnBadge
            && (
              <StyledFromToContainer style={{
                right: 1,
                top: 18,
              }}
              >
                ||
              </StyledFromToContainer>
            )} */}
              <Stack sx={{
                p: '8px',
                boxSizing: 'border-box',
                alignItems: 'center',
                height: '100%',
                ...(isDayInNewYear && {
                  background: 'white',
                  color: `${style.color.black6} !important`,
                }),
              }}
              >
                <Typography
                  component="span"
                  sx={{
                    position: isShowDateCalendarVietNam ? 'absolute' : 'static',
                    color: format(day, 'MM/dd/yyyy') === format(today, 'MM/dd/yyyy') ? '#2474E5' : 'inherit',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    lineHeight: '24px',
                    top: '2px',
                  }}
                  variant="body2"
                >
                  {day.getDate()}

                </Typography>
                {isShowDateCalendarVietNam && (
                <span style={{
                  position: 'absolute',
                  top: '20px',
                  right: '8px',
                  fontWeight: 700,
                  fontSize: '10px',
                  lineHeight: '12px',
                  color: format(day, 'MM/dd/yyyy') === format(today, 'MM/dd/yyyy') ? '#2474E5' : 'inherit',
                  // color: 'rgba(255, 255, 255, 0.8)',
                  ...(isDayInNewYear && { color: '#474747' }),
                }}
                >
                  {dayVN.day}
                  {dayVN.day === 1 && `/ ${dayVN.month}`}
                </span>
                )}

              </Stack>
              <span style={{
                marginTop: '5px',
                fontSize: '10px',
                // position: 'absolute',
                width: '100%',
                // left: 0,
                bottom: isShowDateCalendarVietNam ? '5%' : '20%',
                fontWeight: '500',
                textAlign: 'center',
                // eslint-disable-next-line no-nested-ternary
                color: seo ? '#858585' : (matchDepartDate || matchReturnDate) ? 'white' : (dayPrice && isMinPrice ? style.color.product2 : style.color.black3),
                display: dayPriceObj ? 'block' : 'none',
              }}
              >
                {dayPrice || ''}
              </span>
            </PickersDay>
          </span>
        </Stack>
      );

      return (
        <StyledButton
          style={{
            zIndex: (matchDepartDate || matchReturnDate) ? 1 : 3,
            background: 'white',
          }}
          key={uniqueId()}
        >
          {/* {departBadge} */}
          <DateComponent isShowDateCalendarVietNam={isShowCalendarVietNam || showCalendarLunar} />
          <RedirectAlert
            open={open}
            setOpen={setOpen}
            params={param}
            onConfirm={setSelectedDate}
          />
          {/* {returnBadge} */}
        </StyledButton>
      );
    },
  );

  const CalendarPickerMemo = useMemo(() => (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      locale={vi}
    >
      <CalendarPicker
        className="StyledCalendarPicker"
        views={['day']}
        openTo="day"
        date={null}
        disablePast
        components={{
          LeftArrowButton: Hidden,
          LeftArrowIcon: Hidden,
          RightArrowButton: Hidden,
          RightArrowIcon: Hidden,
          SwitchViewButton: Hidden,
          SwitchViewIcon: Hidden,
        }}
        defaultCalendarMonth={addedMonthDate}
        minDate={new Date()}
        disableHighlightToday={!highlightToday}
        onChange={() => { }}
        renderDay={(day: any, selectedDays: any, pickersDayProps: any) => {
          const date = format(new Date(day), 'yyyy-MM-dd');
          const monthKey = `${date.split('-')[0]}-${date.split('-')[1]}`;
          return (
            <CalendarDateMemo
              key={uniqueId()}
              day={day}
              isMinPrice={dayPriceObj ? minPriceObj[monthKey] === dayPriceObj[date] : false}
              pickersDayProps={pickersDayProps}
              dateNo={day.getDate()}
              month={day.getMonth() + 1}
              year={day.getFullYear()}
            />
          );
        }}
      />
    </LocalizationProvider>
  ), [
    isBetweenDepartAndReturn,
    isBetweenDepartAndReturn
      ? `${selectedDepartDate}-${selectedReturnDate}`
      : '',
    JSON.stringify(dayPriceObj),

  ]);

  return CalendarPickerMemo;
};

type ICustomCalendarProps = ICustomCalendarPickerProps;
const CustomCalendarVex = ({
  highlightToday = false,
  monthAdded = 0,
  dayPriceObj,
  selectedDate,
  setSelectedDate,
  showCalendarLunar,
  showStyleLunar,
  isNotShowPrice,
  seo,
  isVcms,
  lang,
}: ICustomCalendarProps) => (
  <FullWidthStyledBox>
    <StyledBox>
      <CustomCalendarPicker
        seo={seo}
        isNotShowPrice={isNotShowPrice}
        highlightToday={highlightToday}
        monthAdded={monthAdded}
        dayPriceObj={dayPriceObj}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        showCalendarLunar={showCalendarLunar}
        showStyleLunar={showStyleLunar}
        isVcms={isVcms}
        lang={lang}
      />
    </StyledBox>
    {/* <StyledDevider variant="fullWidth" /> */}
  </FullWidthStyledBox>
);

export default CustomCalendarVex;
